import { gql } from 'graphql-tag';

export const GET_INITIAL_SUPPLIER_ACCOUNTS = gql`
  query Id97ff35be29d5ba5d6188206d95cd4957(
    $companyId: ID!
    $filter: AccountPayableFilter!
    $first: Int
  ) {
    __typename
  }
`;
